import type { FiltrosTribos } from './types';

interface Props {
  filtros: FiltrosTribos;
  cidades: string[];
  aoMudar: (f: FiltrosTribos) => void;
}

const SEXOS: { valor: '' | 'M' | 'F'; rotulo: string }[] = [
  { valor: '', rotulo: 'Todos' },
  { valor: 'M', rotulo: 'Homens' },
  { valor: 'F', rotulo: 'Mulheres' },
];

export default function BarraFiltrosTribos({ filtros, cidades, aoMudar }: Props) {
  return (
    <div className="rounded-2xl border border-background-200 bg-white p-3">
      <div className="flex flex-col gap-3 md:flex-row md:items-center">
        <div className="relative min-w-0 flex-1">
          <span className="pointer-events-none absolute left-3 top-1/2 flex h-4 w-4 -translate-y-1/2 items-center justify-center text-foreground-400">
            <i className="ri-search-line text-[15px]" aria-hidden />
          </span>
          <input
            type="text"
            value={filtros.busca}
            onChange={(e) => aoMudar({ ...filtros, busca: e.target.value })}
            placeholder="Buscar por nome"
            className="w-full rounded-full border border-background-200 bg-background-50 py-2 pl-9 pr-3 text-sm text-foreground-900 placeholder:text-foreground-400 focus:border-primary-400 focus:outline-none"
          />
        </div>

        <div className="flex shrink-0 items-center gap-1 rounded-full bg-background-100 px-1 py-1">
          {SEXOS.map((s) => (
            <button
              key={s.rotulo}
              type="button"
              onClick={() => aoMudar({ ...filtros, sexo: s.valor })}
              className={`cursor-pointer whitespace-nowrap rounded-full px-3 py-1.5 text-[13px] font-semibold transition-colors ${
                filtros.sexo === s.valor
                  ? 'bg-secondary-500 text-white'
                  : 'text-foreground-700 hover:bg-white'
              }`}
            >
              {s.rotulo}
            </button>
          ))}
        </div>

        <select
          value={filtros.cidade}
          onChange={(e) => aoMudar({ ...filtros, cidade: e.target.value })}
          className="shrink-0 cursor-pointer rounded-full border border-background-200 bg-white px-3 py-2 text-sm text-foreground-800 focus:border-primary-400 focus:outline-none"
        >
          <option value="">Todas as cidades</option>
          {cidades.map((c) => (
            <option key={c} value={c}>
              {c}
            </option>
          ))}
        </select>

        <button
          type="button"
          onClick={() => aoMudar({ ...filtros, soSem: !filtros.soSem })}
          className={`shrink-0 cursor-pointer whitespace-nowrap rounded-full border px-3 py-2 text-[13px] font-semibold transition-colors ${
            filtros.soSem
              ? 'border-primary-500 bg-primary-500 text-white'
              : 'border-background-300 bg-white text-foreground-800 hover:bg-background-100'
          }`}
        >
          Só sem tribo
        </button>
      </div>
    </div>
  );
}